module.exports = __webpack_public_path__ + "img/beatout-logo-borderless.4476444e.svg";